// src/components/Hero.jsx
import { useEffect, useState } from "react";
import hostelBg from "../assets/images/hostel-hero.png";
import devarajImg from "../assets/images/devaraj.png";
import UpdatesTicker from "./UpdatesTicker";

export default function Hero() {
  const fullText = "Welcome to BCWD Surathkal";
  const [letters, setLetters] = useState([]);

  // Animate title letters
  useEffect(() => {
    const timeouts = [...fullText].map((char, i) =>
      setTimeout(() => setLetters((prev) => [...prev, char]), i * 80)
    );
    return () => timeouts.forEach(clearTimeout);
  }, []);

  // Smooth scroll to About section
  const handleScrollToAbout = (e) => {
    e.preventDefault();
    const aboutSection = document.getElementById("about");
    if (!aboutSection) return;
    const navHeight = 64;
    const offset = aboutSection.getBoundingClientRect().top + window.pageYOffset - navHeight;
    window.scrollTo({ top: offset, behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen w-full bg-cover bg-center flex flex-col justify-center items-center text-center px-4 sm:px-6 md:px-8 lg:px-10 py-20 sm:py-24 md:py-28"
      style={{ backgroundImage: `url(${hostelBg})`, backgroundAttachment: "scroll" }}
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black/50 z-0"></div>

      {/* Hero Content */}
      <div className="relative z-10 flex flex-col items-center space-y-5 sm:space-y-6 md:space-y-7 lg:space-y-8 text-white max-w-6xl mx-auto w-full mt-8 sm:mt-12 md:mt-16">
        {/* Profile Image */}
        <div className="flex flex-col items-center">
  <img
    src={devarajImg}
    alt="Devaraj Aras"
    className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 rounded-full border-2 border-yellow-300 shadow-xl transition duration-300 hover:scale-105"
  />
  <p className="mt-2 text-sm sm:text-base md:text-lg font-semibold text-yellow-100">
    Devaraj Aras
  </p>
</div>


        {/* Animated Title */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-tight max-w-5xl tracking-wide px-2 sm:px-4 drop-shadow-2xl">
          {letters.map((char, i) => (
            <span
              key={i}
              className="inline-block animate-fadeIn"
              style={{ animationDelay: `${i * 0.08}s`, animationFillMode: "backwards" }}
            >
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </h1>

        {/* Description */}
        <p className="text-sm sm:text-base md:text-lg lg:text-xl max-w-sm sm:max-w-lg md:max-w-2xl lg:max-w-3xl px-4 sm:px-6 md:px-8 text-gray-50 leading-relaxed drop-shadow-lg font-medium">
          A Government of Karnataka initiative under the Backward Class Welfare Department, nurturing 1600+ bright futures since 2002.
        </p>

        {/* Call-to-Action */}
        <div className="pt-3 sm:pt-4 md:pt-5">
          <a href="#apply">
            <button className="bg-maroon border-2 border-maroon text-white px-7 sm:px-9 md:px-12 lg:px-14 py-3 sm:py-3.5 md:py-4 rounded-full font-bold hover:bg-white hover:text-maroon hover:border-white transition-all duration-300 shadow-2xl hover:shadow-yellow-400/20 transform hover:scale-105 active:scale-95 text-sm sm:text-base md:text-lg">
              Apply Now
            </button>
          </a>
        </div>
      </div>

      {/* Updates Ticker */}
      <div className="w-full max-w-sm sm:max-w-md md:max-w-2xl lg:max-w-3xl xl:max-w-5xl mt-10 sm:mt-12 md:mt-14 lg:mt-16 px-3 sm:px-4 md:px-6 z-10">
        <UpdatesTicker />
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={handleScrollToAbout}
        className="absolute bottom-8 sm:bottom-10 md:bottom-12 text-white text-3xl sm:text-4xl z-10 animate-bounce cursor-pointer hover:text-yellow-400 transition-colors duration-300 focus:outline-none focus:text-yellow-400"
        aria-label="Scroll to about section"
      >
        ↓
      </button>

      {/* Animation Styles */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn { animation: fadeIn 0.5s ease-out; }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce { animation: bounce 2s ease-in-out infinite; }
      `}</style>
    </section>
  );
}
